import {DICTIONARY} from "./dictionary";
import {Letter, TileData} from "./Tile";

export const GRID_LENGTH = 15;
export const TRAY_LENGTH = 7;
export const ALL_LETTERS_BONUS = 50;

export const enum GridSpotType {
    NORMAL = "tile-normal",
    DOUBLE_WORD = "tile-double-word",
    DOUBLE_LETTER = "tile-double-letter",
    TRIPLE_LETTER = "tile-triple-letter",
    TRIPLE_WORD = "tile-triple-word",
    START = "tile-start"
}



function initialTypeGrid() {
    const tiles: Array<GridSpotType> = [];
    // Building out 15x15 grid from left to right, top to bottom

    function normalize(x: number){
        if(x > 7){
            x = GRID_LENGTH - x - 1;
        }

        return x;
    }

    for (let i = 0; i < GRID_LENGTH; i++) {
        const norm_i = normalize(i);
        for (let j = 0; j < GRID_LENGTH; j++) {
            const norm_j = normalize(j);

            let type = GridSpotType.NORMAL;

            // Double word scores are diagonals
            if(norm_i == norm_j) {
                type = GridSpotType.DOUBLE_WORD;
            }

            // Double letters


            // Triple Letters
            if((norm_i % 4 == 1) && (norm_j % 4 == 1) && !(
                norm_i == 1 && norm_j == 1
            )){
                type = GridSpotType.TRIPLE_LETTER;
            }

            // Double letters
            if((norm_i % 4 == 2) && (norm_j % 4 == 2) && !(
                norm_i == 2 && norm_j == 2
            )){
                type = GridSpotType.DOUBLE_LETTER;
            }

            if(Math.min(norm_i, norm_j)==0 && Math.max(norm_i, norm_j)==3){
                type = GridSpotType.DOUBLE_LETTER;
            }
            if(Math.min(norm_i, norm_j)==3 && Math.max(norm_i, norm_j)==7){
                type = GridSpotType.DOUBLE_LETTER;
            }


            // Triple Word scores
            if((i % 7 == 0) && (j % 7 == 0)){
                type = GridSpotType.TRIPLE_WORD;
            }

            if (i == 7 && j == 7) {
                type = GridSpotType.START;
            }
            tiles.push(type);
        }
    }

    return tiles;
}
export const INITIAL_TYPE_GRID: Array<GridSpotType> = initialTypeGrid();
export const EMPTY_TILE_GRID: Array<TileData> = [];
for(let i=0; i<GRID_LENGTH*GRID_LENGTH; i++){
    EMPTY_TILE_GRID.push(null);
}



export const POINT_LOOKUP: Map<string, number> = new Map();

function letter(letter: string, value: number):Letter{
    POINT_LOOKUP.set(letter, value);

    let is_blank = false;
    if(letter == ''){
        is_blank = true;
    }

    return {
        points: value, str: letter, is_blank: is_blank
    };
}

export function addNTimes<T>(array: Array<T>, item: T, N: number){
    for(let i=0; i<N; i++){
        array.push(item);
    }
    return array;
}

export function generateLetterList(): Array<Letter>{
    const letters: Array<Letter> = [];
    addNTimes(letters, letter('A', 1), 9);
    addNTimes(letters, letter('B', 3), 2);
    addNTimes(letters, letter('C', 3), 2);
    addNTimes(letters, letter('D', 2), 4);
    addNTimes(letters, letter('E', 1), 12);
    addNTimes(letters, letter('F', 4), 2);
    addNTimes(letters, letter('G', 2), 3);
    addNTimes(letters, letter('H', 4), 2);
    addNTimes(letters, letter('I', 1), 9);
    addNTimes(letters, letter('J', 8), 1);
    addNTimes(letters, letter('K', 5), 1);
    addNTimes(letters, letter('L', 1), 4);
    addNTimes(letters, letter('M', 3), 2);
    addNTimes(letters, letter('N', 1), 6);
    addNTimes(letters, letter('O', 1), 8);
    addNTimes(letters, letter('P', 3), 2);
    addNTimes(letters, letter('Q', 10), 1);
    addNTimes(letters, letter('R', 1), 6);
    addNTimes(letters, letter('S', 1), 4);
    addNTimes(letters, letter('T', 1), 6);
    addNTimes(letters, letter('U', 1), 4);
    addNTimes(letters, letter('V', 4), 2);
    addNTimes(letters, letter('W', 4), 2);
    addNTimes(letters, letter('X', 8), 1);
    addNTimes(letters, letter('Y', 4), 2);
    addNTimes(letters, letter('Z', 10), 1);

    // Manually run this twice because I don't want the same letter object to be stored twice
    letters.push(letter('', 0));
    letters.push(letter('', 0));

    return letters;
}

export const DICTIONARY_SET = new Set(DICTIONARY.word);

